import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const issueDateAndReferenceMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.6,
    field: 'issue_date',
    headerName: <Text tId={'ISSUE_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: PayoutsListRowProps) => {
      return (
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: palette.text.primary,
            }}
          >
            <strong>{formatDateTimeReadable(rowData.row.issueDate)}</strong>
          </div>
          <span color={palette.text.secondary}>{rowData.row.reference}</span>
        </div>
      );
    },
  };
};
